import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { PaymentProvider } from '@savgroup-front-common/types/Payment/PaymentProvider';

const ENDPOINT = `${APIConfiguration.payment}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/payments/accounts`;

export interface PaymentAccountSummary {
  id: string;
  name: string;
  description: string;
  paymentProvider: PaymentProvider;
  isBillingGenerated?: boolean;
  isPaymentReceiptGenerated?: boolean;
  isAutomaticRefundAllowed?: boolean;
  token?: {
    publicToken?: string;
  };
  isEnabled: boolean;
  metadata?: Record<string, string | undefined>;
}

interface GetPaymentAccountsBySellerQueryArgs {
  sellerId: string;
}

export const getPaymentAccountsBySellerQuery = async ({
  sellerId,
}: GetPaymentAccountsBySellerQueryArgs): Promise<
  BackResponse<PaymentAccountSummary[]> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    return await apiCall<BackResponse<PaymentAccountSummary[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
